const APP_BASENAME = '/workspace';

export const buildAppUrl = (path: string): string => {
  return `${window.location.origin}${APP_BASENAME}${path}`;
};
